import axios from "axios";
import { useAuth } from "@clerk/react";
import { useMemo } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const pub = axios.create({ baseURL: API });

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const call = async (method, url, data, config = {}) => {
      const token = await getToken();
      const r = await axios({ method, url: `${API}${url}`, data, ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
      return r.data;
    };
    return {
      get: (u, c) => call("get", u, undefined, c), post: (u, d, c) => call("post", u, d, c),
      patch: (u, d) => call("patch", u, d), put: (u, d) => call("put", u, d), del: (u) => call("delete", u),
    };
  }, [getToken]);
}

export const errMsg = (e, fallback) => {
  if (!navigator.onLine) return "offline";
  return e?.response?.data?.message || fallback;
};
